import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
} from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-toggleable",
  templateUrl: "./toggleable.component.html",
})
export class ToggleableComponent implements OnInit {
  readonly defaultToggled = input<boolean>(false);
  readonly entireHeaderClickable = input<boolean>(false);

  toggled: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.toggled = this.defaultToggled();
  }

  toggle(): void {
    this.toggled = !this.toggled;
  }
}
